import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  _id: 0,
  planName: "Free",
  price: 0,
  currency: "MXN",
  description: [],
  routeLimit: 0,
  membershipStatus: "inactive",
  lastPayment: null,
  nextPayment: null,
};

const membershipSlice = createSlice({
  name: "membership",
  initialState,
  reducers: {
    setMembership(state, action) {
      state._id = action.payload._id;
      state.planName = action.payload.planName;
      state.price = action.payload.price;
      state.currency = action.payload.currency;
      state.description = action.payload.description;
      state.routeLimit = action.payload.routeLimit;
      state.membershipStatus = action.payload.membershipStatus;
      state.lastPayment = action.payload.lastPayment;
      state.nextPayment = action.payload.nextPayment;
    },
    setStatusMembership: (state, action) => {
      state.membershipStatus = action.payload.membershipStatus;
    },
    clearMembership(state) {
      state._id = 0;
      state.planName = "Free";
      state.price = 0;
      state.currency = "MXN";
      state.description = [];
      state.routeLimit = 0;
      state.membershipStatus = "inactive";
      state.lastPayment = null;
      state.nextPayment = null;
    },
  },
});

export { initialState };
export const { setMembership, setStatusMembership, clearMembership } =
  membershipSlice.actions;
export default membershipSlice.reducer;
